// @flow
import React from 'react';
import InputCreator, { type $defaultInputProps } from '../../containers/ProductForm/InputCreator';
import { type $TextareaAttributeType } from '../../types/attributes';
import TextInputCounter from '../TextInputCounter';
import './TextArea.css';

class TextArea extends React.Component {
  state = {
    charsRemaining: this.props.attribute.maxLength,
    showCounter: this.props.attribute.maxLength && this.props.attribute.maxLength > 0,
  };

  handleChange = setValue => setError => (attr: $TextareaAttributeType) => (event) => {
    const { value } = event.target;
    setValue(attr.id, value);
    if (!attr.maxLength) {
      return;
    }
    this.updateRemainingState(attr.maxLength - value.length);
    const errorMessage = `Maximum length of the message is ${attr.maxLength} characters.`;
    if (attr.maxLength && value.length > attr.maxLength) {
      return setError(attr.id, errorMessage);
    }
    if (attr.error === errorMessage) {
      setError(attr.id, null);
    }
  };

  updateRemainingState = (remainingCharacters) => {
    this.setState({ charsRemaining: remainingCharacters });
  };

  render() {
    const TA = InputCreator(
      ({
        defaultInputProps,
        setAttributeValue,
        setAttributeError,
        attribute,
      }: {
        defaultInputProps: $defaultInputProps,
        setAttributeValue: Function,
        setAttributeError: Function,
        attribute: $TextareaAttributeType
      }) => (
        <textarea {...defaultInputProps} onChange={this.handleChange(setAttributeValue)(setAttributeError)(attribute)}/>
      ));

    return (
      <div className="textAreaWithCounterWrap">
        <TextInputCounter charsRemaining={this.state.charsRemaining} show={this.state.showCounter} />
        {TA({ renderLabel: null, ...this.props })}
      </div>
    );
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea/index.js